import { ClientLoaderFunctionArgs, useLoaderData } from "react-router";
import CustomError from "@components/Error/CustomError";
import { MetaTagDescriptor } from "@components/MetaTags/MetaTags";
import { EventsAwardsNewsPageContext } from "@events-awards/EventsAwardsNews/utils/types";
import { Route } from "@route-types/Section/layouts/EventsAwards/EventsAwardsNews/+types/EventsAwardsNewsPage";
import { fetchContext, ResponseType } from "@sphtech/web2-core/ssr";
import { HttpStatusCode } from "axios";

import { fetchEventsAwardsNewsPageData } from "./EventsAwardsNews.server";
import EventsAwardsNewsPageContent from "./EventsAwardsNewsPageContent";

/** This is the main entry point component for /events-awards route. */
const EventsAwardsNewsPage = (): React.ReactElement => {
  const context = useLoaderData<EventsAwardsNewsPageContext>();

  // StatusCode is not 200
  if (context && context.statusCode !== HttpStatusCode.Ok) {
    return <CustomError statusCode={context.statusCode} />;
  }

  // Check if payload is missing
  if (typeof context?.payload === "undefined") {
    return <CustomError statusCode={HttpStatusCode.NotFound} />;
  }

  return (
    <EventsAwardsNewsPageContent
      {...context.payload.data}
      gaProps={context.payload.gaProps}
    />
  );
};

export default EventsAwardsNewsPage;

export const loader = async ({ request }: Route.LoaderArgs) => {
  const url = new URL(request.url, `http://localhost`);
  const path = url.pathname;

  return await fetchEventsAwardsNewsPageData(path);
};

export const meta = ({ loaderData }: Route.MetaArgs): MetaTagDescriptor[] => {
  const context = loaderData as EventsAwardsNewsPageContext;

  if (context.type !== ResponseType.SUCCESS) return [];

  const data = context.payload;

  if (!data) return [];
  if (!data.metaTags) return [];

  return data.metaTags;
};

export const clientLoader = async (args: ClientLoaderFunctionArgs) => {
  const result = (await fetchContext(args)) as {
    context?: EventsAwardsNewsPageContext;
  };

  if (!result.context) return await args.serverLoader();

  return result.context;
};
